<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="$t('home.title')"
      :breadCrumbFirstLink="'/'"
      :title="$t('home.title')"
    >
      <div class="form-create__buttons"></div>
    </ToolsPanel>
    <ContentContainer>
      <div class="home"></div>
    </ContentContainer>
  </Main>
</template>

<script>
import Main from "~/templates/Main.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import { getStoredUserInfo } from "~/helpers/userAuth";
import ROUTE from "~/constants/routes";

export default {
  name: "UserCreate",
  metaInfo() {
    return {
      title: this.$t("home.title"),
    };
  },
  data() {
    return {
      data: null,
      user: {},

      admin: false,
      team_lead: false,
      bayer: false,
      af_manager: false,
    };
  },
  components: {
    Main,
    ToolsPanel,
    ContentContainer,
  },
  mounted() {
    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
      if (
        this.user.groups[0].id == 2 ||
        this.user.groups[0].id == 6 ||
        this.user.groups[0].id == 5
      ) {
        this.admin = true;
      } else if (this.user.groups[0].id == 4) {
        this.team_lead = true;
      } else if (this.user.groups[0].id == 3) {
        this.bayer = true;
      } else if (this.user.groups[0].id == 7) {
        this.af_manager = true;
      }
    }

    if (this.af_manager) {
      this.$router.push({
        path: ROUTE.INTEGRATION_LIST.replace(":page", 1),
      });
    } else {
      this.$router.push({
        path: ROUTE.LEAD_LIST.replace(":page", 1),
      });
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.home {
  &__title {
    font-size: 24px;
    padding-bottom: 15px;
    font-weight: bold;
  }
  &__wrap {
    display: flex;
    justify-content: space-between;
  }
  &__list-item {
    font-size: 18px;
    padding-bottom: 10px;
  }
}
</style>
